import { ISystemCreate, ISystemUpdate } from "../../types/system";
import { ITableProps } from "../../types/table";
import { api } from "../api";

const SystemsService = async (name: string, table: ITableProps) => {

    const response = await api.get('systems', {
        params: {
            pageNumber: table.page,
            pageSize: table.pageSize,
            direction: table.direction,
            sortBy: table.sortBy,
            name
        }
    });

    return response;

}

const CreateSystemService = async (data: ISystemCreate) => {

    const response = await api.post('systems', data);

    return response;

}

const UpdateSystemService = async (data: ISystemUpdate) => {

    const response = await api.put(`systems/${data.id}`, data);

    return response;

}

const DeleteSystemService = async (id: number) => {

    const response = await api.delete(`systems/${id}`);

    return response;

}

const ActiveSystemService = async (id: number) => {

    const response = await api.delete(`systems/active/${id}`);

    return response;

}

const AllSystemsService = async (name: string) => {

    const response = await api.get('systems/all', {
        params: {
            name
        }
    });

    return response;

}

export {
    SystemsService,
    CreateSystemService,
    UpdateSystemService,
    DeleteSystemService,
    ActiveSystemService,
    AllSystemsService
}